var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bar-chart"},_vm._l((_vm.chartData),function(bar,idx){return _c('div',{key:bar.name},[_c('div',[_vm._v(_vm._s(bar.name)+": "+_vm._s(bar.value))]),_c('Bar',{attrs:{"color":_vm.colors[idx],"value":bar.value}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }